export default __webpack_public_path__ + "static/media/faith-cover.1d258070.jpg";